import React from 'react'
import { Route, IndexRoute } from 'react-router'
import NotFoundPage from 'components/NotFoundPage'

const maybeLinkToExternalAppOnRouteEnter = (nextState, replace, proceed) => {
  if (['PRODUCTION' , 'MASTER'].includes(__ENV__)) {
    // NOTE: We explicitly do NOT call proceed() so that the UI blocks
    // until redirect is complete. This ensures we avoid undesireable flash
    // of content.
    return window.location.href = window.location.href
  } else {
    // Local Development Environment; proceed to Fallback page.
    return proceed()
  }
}

const ConversationRoutes = () => (
  <Route path="inboxes" onEnter={maybeLinkToExternalAppOnRouteEnter}>
    <IndexRoute component={NotFoundPage}/>
    <Route path="*" component={NotFoundPage}/>
  </Route>
)

export default ConversationRoutes



// WEBPACK FOOTER //
// ./src/scripts/app/routes/ConversationRoutes.js